import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Avatar,
  Typography,
  Descriptions,
  Button,
  Form,
  Select,
  Input,
  Upload,
  message,
  DatePicker,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { HrApi, imageApi } from "../../../initialpage/hooks/HrApi";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import useAuth from "../../../initialpage/hooks/useAuth";
import Cookies from "js-cookie"
import moment from "moment";
const { Title } = Typography;
const { Option } = Select;

function getBase64(file, callback) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => callback(reader.result);
  reader.onerror = (error) => console.error("Base64 error:", error);
}

const SingleProfile = () => {
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState({});
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const user = JSON.parse(Cookies.get("user") || '{}');
  const [photoPath, setPhotoPath] = useState("");
  const [designationData, setDesignationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [designationId, setDesignationId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);
  const emp_id = Cookies.get("E_Id");


  useEffect(() => {
    const getUserDetails = () => {
      fetch(`${HrApi}/hr/emp/getAllEmployeById/${emp_id}`)
        .then((res) => {
          if (res.status >= 400) throw new Error("Server responds with error!");
          return res.json();
        })
        .then((users) => {
          setEmployeeData(users.data);
          form.setFieldsValue({
            registrationNo: users.data.EMPLOYE_REGISTRATION_NUMBER || "",
            name: users.data.NAME_ENGLISH || "",
            designation: users.data.DESIGNATION || undefined,
            department: users.data.DEPARTEMENT || undefined,
            mobile: users.data.MOBILE_PHONE || "",
            email: users.data.EMAIL_ADRESS || "",
            joining_date: users.data.JOINING_DATE
              ? moment.utc(users.data.JOINING_DATE)
              : null || "",
            cadre: users.data.CADRE || "",
          });
          setImageUrl(`${imageApi}${users.data.PHOTO_PATH}`);
          setPhotoPath(users.data.PHOTO_PATH);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching employee:", err);
        });
    };

    if (emp_id) getUserDetails();
  }, [emp_id, form, loading]);

  const handleBeforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    getBase64(file, async (base64Url) => {
      setImageUrl(base64Url);

      try {
        const response = await fetch(`${imageApi}/upload-base64`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ base64Image: base64Url }),
        });

        if (!response.ok) throw new Error(`Server error: ${response.status}`);
        const data = await response.json();
        setPhotoPath(data.path);
      } catch (error) {
        console.error("Base64 upload failed:", error);
        message.error("Image upload failed! Is the server running?");
      }
    });

    return false;
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload Photo</div>
    </div>
  );

  const onFinish = (values) => {
    const data = {
      registrationNo: values.registrationNo,
      name: values.name,
      mobile: values.mobile,
      email: values.email,
      joining_date: values.joining_date
        ? values.joining_date
        : null,
      cadre: values.cadre,
      image: photoPath,
      employe_id: emp_id,
      // Use changed ID if available, otherwise fall back to original
      designation_id: designationId ?? employeeData.DESIGNATION_ID,
      department_id: departmentId ?? employeeData.DEPARTEMENT_ID,
    };
    console.log(data);
    axios
      .put(`${HrApi}/hr/emp/putEmployee`, data, {
        headers: { Authorization: "Bearer ..." },
      })
      .then((res) => {

        console.log(res);
        if (res.data.data.affectedRows === 1) {
          message.success("Employee information updated successfully!");
          form.resetFields();
          setImageUrl(null);
          setDesignationId(null);
          setDepartmentId(null);
          setLoading(true);
          window.$("#edit_employee").modal("hide");
        }
      });
  };

  console.log(employeeData);

  // designation get
  useEffect(() => {
    fetch(`${HrApi}/hr/setting/get/designation`)
      .then((res) => {
        if (res.status >= 400) throw new Error("Server responds with error!");
        return res.json();
      })
      .then((data) => setDesignationData(data.items))
      .catch(console.error);
  }, []);

  useEffect(() => {
    fetch(`${HrApi}/hr/setting/get/department`)
      .then((res) => {
        if (res.status >= 400) throw new Error("Server responds with error!");
        return res.json();
      })
      .then((users) => setDepartmentData(users.items))
      .catch(console.error);
  }, []);

  return (
    <div className=" page-wrapper">
      {!employeeData ? (
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      ) : (
        <Row justify="center" style={{ padding: "20px" }}>
          <Col xs={24} md={20} lg={16}>
            <Card
              style={{
                borderRadius: "16px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                padding: "20px",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <Avatar
                  size={200}
                  src={
                    employeeData.PHOTO_PATH
                      ? `${imageApi}${employeeData.PHOTO_PATH}`
                      : "https://via.placeholder.com/120"
                  }
                  style={{ marginBottom: "10px" }}
                />
                <Title level={3}>
                  {employeeData?.NAME_ENGLISH || "Employee Name"}
                </Title>
                <p style={{ color: "#888" }}>
                  {employeeData?.DESIGNATION || "Designation"}
                </p>
              </div>

              <Descriptions
                bordered
                column={{ xs: 1, sm: 1, md: 2 }}
                labelStyle={{ fontWeight: 600 }}
                contentStyle={{ backgroundColor: "#fafafa" }}
              >
                <Descriptions.Item label="Employee ID">
                  {employeeData?.EMPLOYE_REGISTRATION_NUMBER || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Department">
                  {employeeData?.DEPARTEMENT || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Mobile Number">
                  {employeeData?.MOBILE_PHONE || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Email">
                  {employeeData?.EMAIL_ADRESS || "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Joining Date">
                  {employeeData?.JOINING_DATE
                    ? moment.utc(employeeData.JOINING_DATE).format("DD-MM-YYYY")
                    : "N/A"}
                </Descriptions.Item>
                <Descriptions.Item label="Cadre">
                  {employeeData?.CADRE || "N/A"}
                </Descriptions.Item>
              </Descriptions>

              <div style={{ marginTop: "30px", textAlign: "center" }}>
                <Button
                  type=""
                  className="buttonColor"
                  onClick={() => navigate(-1)}
                >
                  Back to Employee List
                </Button>
                <Button
                  type=""
                  className="ms-4 buttonColor"
                  data-toggle="modal"
                  data-target="#edit_employee"
                >
                  <i className="fa fa-edit me-3" aria-hidden="true"></i> Edit
                </Button>
              </div>
            </Card>

            <div
              id="edit_employee"
              className="modal custom-modal fade"
              role="dialog"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Information</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body text-start">
                    <Row justify="center" align="middle">
                      <Col xs={24}>
                        <Form
                          form={form}
                          layout="vertical"
                          onFinish={onFinish}
                          style={{
                            padding: "24px",
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="registrationNo"
                                label="Employee Serial No."
                                rules={[
                                  {
                                    pattern: /^EMP\d{4}-\d{3}$/,
                                    message:
                                      "Format should be like EMP2025-001",
                                  },
                                ]}
                              >
                                <Input placeholder="e.g., EMP2025-001" />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                name="name"
                                label="Employee Name"
                                rules={[
                                  {
                                    min: 3,
                                    message:
                                      "Name must be at least 3 characters",
                                  },
                                ]}
                              >
                                <Input placeholder="e.g., John Doe" />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item name="designation" label="Designation">
                                <Select
                                  placeholder="Select designation"
                                  onChange={(value) => setDesignationId(value)}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option?.children
                                      ?.toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {designationData?.map((item) => (
                                    <Option
                                      key={item.designation_id}
                                      value={parseInt(item.designation_id)}
                                    >
                                      {item.designation}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item name="department" label="Department">
                                <Select
                                  placeholder="Select department"
                                  onChange={(value) => setDepartmentId(value)}
                                  showSearch
                                  filterOption={(input, option) =>
                                    option?.children
                                      ?.toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {departmentData?.map((item) => (
                                    <Option
                                      key={item.departement_id}
                                      value={parseInt(item.departement_id)}
                                    >
                                      {item.departement}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                name="mobile"
                                label="Mobile Number"
                                rules={[
                                  {
                                    pattern: /^01[3-9]\d{8}$/,
                                    message:
                                      "Invalid Bangladeshi mobile number",
                                  },
                                ]}
                              >
                                <Input placeholder="e.g., 017XXXXXXXX" />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                name="email"
                                label="Email"
                                rules={[
                                  {
                                    type: "email",
                                    message: "Please enter a valid email",
                                  },
                                ]}
                              >
                                <Input placeholder="e.g., john.doe@example.com" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="joining_date"
                                label="Joining Date"

                              >
                                <DatePicker
                                  style={{ width: "100%" }}
                                  format="DD-MM-YYYY"
                                  placeholder="Select joining date"
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                              <Form.Item
                                name="cadre"
                                label="Cadre"

                              >
                                <Select placeholder="Select cadre">
                                  {Array.from({ length: 100 }, (_, i) => (
                                    <Option key={i + 1} value={i + 1}>
                                      {i + 1}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>

                            <Col xs={24}>
                              <Form.Item label="Employee Photo">
                                <Upload
                                  name="avatar"
                                  listType="picture-card"
                                  className="avatar-uploader"
                                  showUploadList={false}
                                  beforeUpload={handleBeforeUpload}
                                >
                                  {imageUrl ? (
                                    <img
                                      src={imageUrl}
                                      alt="avatar"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  ) : (
                                    uploadButton
                                  )}
                                </Upload>
                              </Form.Item>
                            </Col>
                          </Row>

                          <Form.Item style={{ textAlign: "center" }}>
                            <Button
                              type=""
                              className="buttonColor"
                              htmlType="submit"
                              size="large"
                            >
                              Submit Employee Information
                            </Button>
                          </Form.Item>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};
export default SingleProfile;
